<template>
  <v-container fluid class="mr-4 ml-4">
    <v-row>
      <v-col>
        <div class="title-container">
          <h1 class="h1">Prontuário</h1>
        </div>
      </v-col>
    </v-row>

    <v-row >
        <v-col  class="text-center mr-15 ml-15">
            <v-autocomplete  v-model="lista_pacientes_selecionado"  :items="lista_pacientes"  item-text="nome"  item-value="id"  label=" Paciente"  outlined  dense  clearable  :loading="isLoadingPacientes"  @change="handlePacienteSelecionado"/>
      </v-col>
        <!-- <v-col  class="text-center mr-5 ml-5">
            <v-autocomplete  v-model="pacienteSelecionado"  :items="pacientes"  item-text="nome"  item-value="id"  label="Selecione um paciente"  outlined  dense  clearable  :loading="isLoadingProntuario"  @click="abrirDropdown"/>
      </v-col> -->
    </v-row>
    <v-row v-if="isLoadingProntuario">
        <v-col class="text-center blod_color">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <p class="blod_color">Carregando informações do paciente...</p>
        </v-col>
    </v-row>
    <!-- Divisor -->
   
    <v-row dense>
        <v-col v-if="pacienteDetalhado">
            <h3 class="blod_color text-center">
                Modalidade:  {{ descricaoModalidade.texto ? `" ${descricaoModalidade.texto} "` : '' }} 
                <span :style="{ color: descricaoModalidade.cor }">
                    - {{ descricaoModalidade.mensagem }}
                </span>
                <hr class="estilo-linha" />
            </h3>
        </v-col>
    </v-row>
    <p></p>

    <div class="scroll-content" v-if="pacienteDetalhado">

        <v-row v-if="pacienteDetalhado">
        <!-- Dados Pessoais -->
            <!-- Coluna 1 -->
            <v-col cols="6" md="6">
                <h3 class="blod_color text-center"><b>Dados Pessoais</b></h3>
                <p></p>
                <p><b class="blod_color">Paciente: </b> ID: {{pacienteDetalhado.id }} - {{ pacienteDetalhado.nome }}</p>
                <p><b class="blod_color">Data de Nascimento:</b> {{ formatDate(pacienteDetalhado.data_nascimento) }} - ({{ calcularIdade(pacienteDetalhado.data_nascimento) }} anos)</p>
                <p><b class="blod_color">Responsável:</b> {{ pacienteDetalhado.responsavel || 'Não informado' }}</p>
                <p>
                    <b class="blod_color">Telefone:</b>
                    {{ formatPhone(pacienteDetalhado.telefone) }}
                    <a :href="`tel:${pacienteDetalhado.telefone}`" style="color: inherit; text-decoration: none;">
                        <v-icon medium class="mr-1" color="blue">mdi-phone</v-icon>
                    </a>
                    <a :href="`https://wa.me/55${pacienteDetalhado.telefone}`" target="_blank" style="margin-left: 10px;">
                        <v-icon color="green" style="font-size: 22px;">mdi-whatsapp</v-icon>
                    </a>
                </p>

                <p><b class="blod_color">RG:</b> {{ pacienteDetalhado.rg || 'Não informado' }}</p>
                <p><b class="blod_color">CPF:</b> {{ pacienteDetalhado.cpf || 'Não informado' }}</p>
                <p><b class="blod_color">Sexo:</b> {{ pacienteDetalhado.sexo_biologico  || 'Não informado' }}</p>
                <p><b class="blod_color">CID:</b> {{ detalhePrincipal?.cid_nome || ''}} - {{ detalhePrincipal?.cid_descricao || '' }}</p>
                <p><b class="blod_color">Médico Responsável:</b> Dr.(a) {{ detalhePrincipal?.medico_apelido || 'Não informado' }}</p>
                
            
                
                <p><b class="blod_color">Operadora:</b> {{ detalhePrincipal?.operadora  || 'Não informado' }}</p>

                <h3 class=" blod_color mt-4"><b>Endereço</b></h3>
                    <div v-if="pacienteDetalhado.endereco.length">
                    <p>
                        {{ pacienteDetalhado.endereco[0]?.logradouro }},
                        Nº {{ pacienteDetalhado.endereco[0]?.nr }},
                        {{ pacienteDetalhado.endereco[0]?.bairro }} -
                        {{ pacienteDetalhado.endereco[0]?.municipio.localidade }} /
                        {{ pacienteDetalhado.endereco[0]?.uf.sigla }}
                    </p>
                    </div>
                    <div v-else>
                    <p><i>Endereço não cadastrado</i></p>
                    </div>  
                <p v-if="pacienteDetalhado.geolocalizacao">
                <b class="blod_color">Geolocalização:</b>
                <a
                    :href="`https://www.google.com/maps?q=${pacienteDetalhado.geolocalizacao}`"
                    target="_blank"
                    style="margin-left: 10px;"
                >
                    <v-icon color="red">mdi-map-marker</v-icon>
                    Abrir no mapa
                </a>
                </p>

                <p v-else>
                <b class="blod_color">Geolocalização:</b> Não informado
                </p>
                <p><b class="blod_color">Paliativo:</b> {{ pacienteDetalhado.paliativo  ? 'Sim' : 'Não' }}</p>
                <p><b class="blod_color">Liminar:</b> {{ pacienteDetalhado.liminar  ? 'Sim' : 'Não' }}</p>
                <p><b class="blod_color">Alergia: </b> {{pacienteDetalhado.alergia || 'Nega Alergia' }}</p>
                <p><b class="blod_color">Tipo Sanguíneo:</b> {{ detalhePrincipal.tiposanguineo || 'Não informado' }}</p>
                <p><b class="blod_color">Peso: </b> {{detalhePrincipal?.peso || 'Não Informado' }}</p>
                <p><b class="blod_color">Altura: </b> {{detalhePrincipal?.altura || 'Não Informado' }}</p>
                <p > <b class="blod_color">TQT: </b> {{ tqt || 'Não Informado' }} {{detalhePrincipal?.numeracao_tqt || ''}}</p>
                <p > <b class="blod_color">GTT: </b> {{ gtt || 'Não Informado' }} {{detalhePrincipal?.tamanho_gtt || ''}}</p>
                <p><b class="blod_color">Usa Respirador: </b> {{pacienteDetalhado.respirador ? 'Sim': 'Não' }}</p>
                <p v-if="pacienteDetalhado.respirador"><b class="blod_color">Modo de Uso: </b> {{detalhePrincipal?.uso_respirador || 'Não Informado' }}</p>
                <p v-if="pacienteDetalhado.respirador"> <b class="blod_color">Modelo do Ventilador: </b> {{ modoVentilatorio || 'Não Informado' }} </p>
                <p v-if="pacienteDetalhado.respirador"><b class="blod_color">Parâmetros: </b> VC: {{detalhePrincipal?.ventilador_vc  }}; FR: {{detalhePrincipal?.ventilador_fr}}; IPAP: {{detalhePrincipal?.ventilador_ipap  }}; EPAP: {{detalhePrincipal?.ventilador_epap  }}; TINS: {{detalhePrincipal?.ventilador_tins  }}.</p>
                <hr class="estilo-linha" />
                <h3 class="blod_color text-center"><b>Quandro Clínico</b></h3>
                <p> {{ detalhePrincipal?.quadro_clinico  || 'Não Cadastrada ' }}</p>
                <!-- Seção Round -->
                <hr class="estilo-linha" />
                <h3 class="blod_color text-center"><b>Round</b></h3>
                <div v-if="roundMaisRecente">
                <p><b class="blod_color">Data:</b> {{ formatDate(roundMaisRecente.data) }}</p>
                <p><b class="blod_color">Ocorrência:</b> {{ roundMaisRecente.ocorrencia || 'Não informada' }}</p>
                <p><b class="blod_color">Meta:</b> {{ roundMaisRecente.meta || 'Não informada' }}</p>
                <p><b class="blod_color">Conduta</b> {{ roundMaisRecente.desfecho_final || 'Não informado' }}</p>
                </div>
                <div v-else>
                <p><i>Nenhuma informação de Round encontrada.</i></p>
                </div>
                  <hr class="estilo-linha" />
                  <v-row class="mt-4" justify="center">
                    <v-col cols="12" md="4" class="d-flex justify-center">
                      <v-btn color="primary" block @click="modalExames = true">Exames</v-btn>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex justify-center">
                      <v-btn color="primary" block @click="modalEvolucoes = true">Evoluções</v-btn>
                    </v-col>
                  </v-row>

                  <v-row class="mt-4" justify="center">
                    <v-col cols="12" md="4" class="d-flex justify-center">
                      <v-btn color="primary" block @click="modalEquipamentos = true">Equipamentos</v-btn>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex justify-center">
                      <v-btn color="primary" block @click="modalPrescricao = true">Prescrição</v-btn>
                    </v-col>
                  </v-row>

                  <v-row class="mt-4" justify="center">
                    <v-col cols="12" md="4" class="d-flex justify-center">
                      <v-btn color="primary" block @click="modalIntercorrencia = true">Intercorrência</v-btn>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex justify-center">
                      <v-btn color="primary" block @click="modalOcorrencia = true">Ocorrência</v-btn>
                    </v-col>
                  </v-row>


                 <!-- Prescricao -->
                  <v-dialog v-model="modalPrescricao"  max-width="70%" scrollable>
                    <v-card style="max-height: 70vh;">
                      <v-card-title class="headline blod_color  justify-center">Prescrição do Paciente</v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="red" @click="modalPrescricao = false">Fechar</v-btn>
                      </v-card-actions>
                      <v-card-text>
                        <template v-if="(pacienteDetalhado.prescricoes || []).length">
                          <v-list>
                            <v-list-item
                              v-for="(item, index) in (pacienteDetalhado.prescricoes || [])"
                              :key="index"
                            >
                              <v-list-item-content>
                                  <hr class="estilo-linha" />
                                 <p><b>Produto:</b> {{ item.medicamento }}</p>
                                 <p><b>Frequência:</b> {{ item.frequencia }}</p>
                                 <p><b>SOS:</b> {{ item.sos ? 'Sim': 'Não' }}</p>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </template>
                        <template v-else>
                          <p class="text-center mt-4 blod_color"><i>Nenhum prescrição ativa para este paciente.</i></p>
                        </template>
                      </v-card-text>
                      
                    </v-card>
                  </v-dialog>
                 <!-- Exames -->
                  <v-dialog v-model="modalExames"  max-width="70%" scrollable>
                    <v-card style="max-height: 70vh;">
                      <v-card-title class="headline blod_color  justify-center">Exames do Paciente</v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="red" @click="modalExames = false">Fechar</v-btn>
                      </v-card-actions>
                      <v-card-text>
                        <template v-if="(pacienteDetalhado.exame || []).length">
                          <v-list>
                            <v-list-item
                              v-for="exame in (pacienteDetalhado.exame || []).slice().sort((a, b) => b.id - a.id)"
                              :key="exame.id"
                            >
                              <v-list-item-content>
                                  <hr class="estilo-linha" />
                                <v-btn
                                  color="primary"
                                  text
                                  @click="abrirExame(exame.arquivo)"
                                  style="white-space: normal; text-align: left;"
                                >
                                  {{ getNomeArquivo(exame.arquivo) }}
                                </v-btn>
                              </v-list-item-content>
                            </v-list-item>

                          </v-list>
                        </template>
                        <template v-else>
                          <p class="text-center mt-4 blod_color"><i>Nenhum exame carregado para este paciente.</i></p>
                        </template>
                      </v-card-text>
                      
                    </v-card>
                  </v-dialog>
                  <!-- Evolcuoes -->
                  <v-dialog v-model="modalEvolucoes" max-width="70%" scrollable>
                    <v-card style="max-height: 70vh;">
                      <v-card-title class="headline blod_color  justify-center">Evoluções do Paciente</v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="red" @click="modalEvolucoes = false">Fechar</v-btn>
                      </v-card-actions>
                      <v-card-text>
                         <template v-if="(evolucao || []).length">
                        <v-list>
                          <v-list-item
                            v-for="(item, index) in evolucao.slice().sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))"
                            :key="index"
                          >
                            <v-list-item-content>
                                <hr class="estilo-linha" />
                              <p><b>Data da Evolução:</b> {{ formatData(item.timestamp) }} - <b>Horário:</b> {{ formatHora(item.hora_inicio) }}</p>
                              <p><b>Profissional:</b> {{ item.profissional }} - {{ item.especialidade }}</p>
                              <p><b>Procedimento:</b> {{ item.procedimento }}</p>
                              <p><b>Texto da Evolução:</b> {{ item.texto_evolucao }}</p>
                              <p><b>Diagnóstico Clínico:</b> {{ item.diagnostico_clinico }}</p>
                              <p><b>Conduta:</b> {{ item.conduta }}</p>
                              <v-divider class="mt-2 mb-2"></v-divider>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                         </template>
                        <template v-else>
                          <p class="text-center mt-4 blod_color"><i>Nenhum evolução carregado para este paciente.</i></p>
                        </template>
                      </v-card-text>
                      
                    </v-card>
                  </v-dialog>
                  <!-- Equipamentos -->
                  <v-dialog v-model="modalEquipamentos" max-width="70%" scrollable>
                    <v-card style="max-height: 70vh;">
                      <v-card-title class="headline blod_color  justify-center">Equipamentos do Paciente</v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="red" @click="modalEquipamentos = false">Fechar</v-btn>
                      </v-card-actions>
                      <v-card-text>
                         <template v-if="(equipamentos || []).length">
                        <v-list>
                          <v-list-item
                            v-for="(item, index) in equipamentos"
                            :key="index"
                          >
                            <v-list-item-content>
                                <hr class="estilo-linha" />
                              <p><b>Equipamento:</b> {{ item.nome_equipamento?.nome || '' }}</p>
                              <p><b>Disponibilidade:</b> {{ item.disponibilidade?.nome || '' }}</p>
                              <p><b>Data da Implantação:</b> {{ formatData(item.data_implantacao) || '' }}</p>
                              <v-divider class="mt-2 mb-2"></v-divider>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                         </template>
                        <template v-else>
                          <p class="text-center mt-4 blod_color"><i>Nenhum equipamento com este paciente.</i></p>
                        </template>
                      </v-card-text>
                      
                    </v-card>
                  </v-dialog>
                  <!-- Intercorrência -->
                  <v-dialog v-model="modalIntercorrencia" max-width="70%" scrollable>
                    <v-card style="max-height: 70vh;">
                      <v-card-title class="headline blod_color  justify-center">Intercorrências</v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="red" @click="modalIntercorrencia = false">Fechar</v-btn>
                      </v-card-actions>
                      <v-card-text>
                         <template v-if="(intercorrencia || []).length">
                        <v-list>
                          <v-list-item
                            v-for="(item, index) in intercorrencia"
                            :key="index"
                          >
                            <v-list-item-content>
                                <hr class="estilo-linha" />
                              <p><b>Data do Acionamento:</b> {{ formatData(item.data) || '' }}</p>
                              <p><b>Quem Registrou:</b> {{ item.colaborador?.apelido || '' }} - {{ item.colaborador?.especialidade.nome || '' }}</p>
                              <p><b>Que Acionou:</b> {{ item.quem_acionou || '' }}</p>
                              <p><b>Causa:</b> {{ item.causa?.nome || '' }}</p>
                              <p><b>Gerou Hospitalização:</b> {{ item.reinternacao ? 'Sim': 'Não' }}</p>
                              <p><b>Registro:</b> {{ item.observacao || '' }}</p>
                              <v-divider class="mt-2 mb-2"></v-divider>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                         </template>
                        <template v-else>
                          <p class="text-center mt-4 blod_color"><i>Nenhuma Intercorrência com este paciente.</i></p>
                        </template>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                  <!-- Ocorrência -->
                  <v-dialog v-model="modalOcorrencia" max-width="70%" scrollable>
                    <v-card style="max-height: 70vh;">
                      <v-card-title class="headline blod_color  justify-center">Ocorrências</v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="red" @click="modalOcorrencia = false">Fechar</v-btn>
                      </v-card-actions>
                      <v-card-text>
                         <template v-if="(ocorrencia || []).length">
                        <v-list>
                          <v-list-item
                            v-for="(item, index) in ocorrencia"
                            :key="index"
                          >
                            <v-list-item-content>
                                <hr class="estilo-linha" />
                              <p><b>Data do Acionamento:</b> {{ formatData(item.data) || '' }}</p>
                              <p><b>Quem Registrou:</b> {{ item.colaborador?.apelido || '' }} - {{ item.colaborador?.especialidade.nome || '' }}</p>
                              <p><b>Tipo de Ocorrência:</b> {{ item.tipo_ocorrencia?.nome || '' }}</p>
                              <p><b>Registro:</b> {{ item.observacao || '' }}</p>
                              <v-divider class="mt-2 mb-2"></v-divider>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                         </template>
                        <template v-else>
                          <p class="text-center mt-4 blod_color"><i>Nenhuma Ocorrência com este paciente.</i></p>
                        </template>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
            </v-col>

            <!-- Coluna 2 -->
            <v-col cols="6" md="6">
                <p></p>
                <p></p>
                <!-- Plano Terapeurtico  -->
                <h3 class="blod_color text-center" ><b>Plano Terapêuticor</b></h3> <p></p>
                
                <p></p>
                    <ul>
                        <li v-for="(e, index) in planoTerapeuticoOrdenado" :key="index">
                            {{ e.procedimento || 'Procedimento não informado' }} - {{ e.frequencia || 'Frequência não informada' }}
                        </li>
                    </ul>

                    <hr class="estilo-linha" />
                    <p></p>
                    <p></p>
                <!-- Equipe Multi -->
                <h3 class="blod_color text-center" ><b>Equipe Multidisciplinar</b></h3>  <p></p>
                    <ul>
                    <li
                        v-for="e in pacienteDetalhado.equipe_multi_disciplinar
                        .slice()
                        .sort((a, b) => a.especialidade.nome.localeCompare(b.especialidade.nome))"
                        :key="e.id"
                    >
                        {{ e.apelido }} - {{ e.especialidade.nome }} - Tel.: {{ e.tel }}
                        <a :href="`tel:${pacienteDetalhado.telefone}`" style="color: inherit; text-decoration: none;">
                            <v-icon medium class="mr-1" color="blue">mdi-phone</v-icon>
                        <a :href="`https://wa.me/55${pacienteDetalhado.telefone}`" target="_blank" style="margin-left: 10px;">
                            <v-icon color="green" style="font-size: 22px;">mdi-whatsapp</v-icon>
                        </a>
                    </a>
                    </li>
                    </ul>
                    <hr class="estilo-linha" />
                    <p></p>
                    <p></p>
                    <!-- Meta -->
                    <h3 class="blod_color text-center" ><b>Meta por Especialidade</b></h3> <p></p>
                    <ul>
                    <li
                        v-for="e in (pacienteDetalhado.texto_meta || [])"

                        :key="e.id"
                    >
                    {{ e.especialidade }} - {{e.texto_meta}}
                    </li>
                    </ul>
                    <hr class="estilo-linha" />

            

            </v-col>
        </v-row>
    </div>
  </v-container>
</template>

<script>
import api from '@/http';

export default {
  data() {
    return {
        loadingIntercorrencia: false,
        loadingOcorrencia: false,
        loadingRound: false,
        isLoadingPacientes: false,
        pacientes: [],
        isLoadingProntuario: false,
        pacienteSelecionado: null,
        lista_pacientes_selecionado: null,
        round: [],
        modalExames: false,
        modalEvolucoes: false,
        modalEquipamentos: false,
        modalPrescricao: false,
        modalIntercorrencia: false,
        modalOcorrencia: false,
        evolucao: [],
        equipamentos: [],
        intercorrencia: [],
        ocorrencia: [],
        lista_pacientes: [],
    };
  },
  computed: {
    pacienteDetalhado() {
      return this.pacientes.find(p => p.id === this.pacienteSelecionado) || null;
    },
    detalhePrincipal() {
        const detalhes = this.pacienteDetalhado?.detalhes;
        return Array.isArray(detalhes) && detalhes.length > 0 ? detalhes[0] : {};
    },
    modoVentilatorio() {
        const detalhes = this.pacienteDetalhado?.detalhes?.[0];
        try {
        return detalhes && detalhes.modo_ventilatorio_obj
            ? JSON.parse(detalhes.modo_ventilatorio_obj)?.tipo
            : null;
        } catch (e) {
        return null;
        }
    },     
    tqt() {
        const detalhes = this.pacienteDetalhado?.detalhes?.[0];
        try {
        return detalhes && detalhes.tqt_obj
            ? JSON.parse(detalhes.tqt_obj)?.modelo
            : null;
        } catch (e) {
        return null;
        }
    },     
    gtt() {
        const detalhes = this.pacienteDetalhado?.detalhes?.[0];
        try {
        return detalhes && detalhes.gtt_obj
            ? JSON.parse(detalhes.gtt_obj)?.tipo
            : null;
        } catch (e) {
        return null;
        }
    },
    descricaoModalidade() {
      const plano = this.pacienteDetalhado?.plano_terapeutico?.[0];
      const paciente = this.lista_pacientes.find(p => p.id === this.pacienteSelecionado);
      const isCasoEspecial = paciente?.urgencia_emergencia === true;

      if (!plano || !plano.modalidade) {
        if (isCasoEspecial) {
          return {
            texto: '',
            mensagem: 'URGÊNCIA e EMERGÊNCIA - "Caso Especial"',
            cor: 'green',
          };
        }
        return {
          texto: '',
          mensagem: 'Paciente não está em atendimento e não tem direito a URGÊNCIA e EMERGÊNCIA',
          cor: 'red',
        };
      }

      const idsComUrgencia = [1, 3, 4, 5];
      const idModalidade = Number(plano.modalidade_id);
      const temUrgencia = idsComUrgencia.includes(idModalidade);

      let mensagem = '';
      let cor = '';

      if (temUrgencia) {
        mensagem = 'URGÊNCIA e EMERGÊNCIA';
        cor = 'green';
      } else if (isCasoEspecial) {
        mensagem = 'URGÊNCIA e EMERGÊNCIA - "Caso Especial"';
        cor = 'green';
      } else {
        mensagem = 'Não tem direito a URGÊNCIA e EMERGÊNCIA';
        cor = 'red';
      }

      return {
        texto: plano.modalidade,
        mensagem,
        cor,
      };
    },
    roundMaisRecente() {
        if (!this.pacienteSelecionado || !this.round.length) return null;

        const roundsDoPaciente = this.round.filter(
        r => r.paciente?.id === this.pacienteSelecionado
        );

        if (!roundsDoPaciente.length) return null;

        const maisRecente = roundsDoPaciente.reduce((maisNovo, atual) => {
        return new Date(atual.data) > new Date(maisNovo.data) ? atual : maisNovo;
        });

        return maisRecente;
    },
    planoTerapeuticoOrdenado() {
        const lista = this.pacienteDetalhado?.plano_terapeutico;
        if (!Array.isArray(lista)) return [];
        return lista
        .slice()
        .sort((a, b) => (a.procedimento || '').localeCompare(b.procedimento || ''));
    },
  },
  methods: {
    async getPacientes() {
      this.isLoadingPacientes = true;
      try {
        const { data } = await api.get(`/pacientes/app-pacientes/`);
        this.lista_pacientes = data.filter(item => item.ativo);
        // console.log(this.lista_pacientes)
      } catch (error) {
        this.$toast.error(`Erro ao carregar prontuário: ${error}`);
      } finally {
        this.isLoadingPacientes = false;
      }
    },
    async handlePacienteSelecionado(id) {
    if (!id) return;

    this.pacienteSelecionado = null;  // resetar seleção anterior
    this.isLoadingProntuario = true;

    try {
        const { data } = await api.get(`/remocao/prontuario_resumo/?paciente=${id}`);
        const paciente = data.find(p => p.id === id);

        if (paciente) {
        this.pacientes = [paciente];
        this.pacienteSelecionado = paciente.id;
        this.isLoadingProntuario = false;
        this.getEvolucao();
        this.getEquipamento();
        }
    } catch (error) {
        this.$toast.error(`Erro ao buscar paciente: ${error}`);
    } finally {
        this.isLoadingProntuario = false;
    }
    },
    async getRound() {
        this.loadingRound = true;
        try {
            const response = await api.get("/round/rounds/");
            this.round = response.data;
            // console.log('this.round', this.round)
        } catch (error) {
            this.$toast.error(`Desculpe! Aconteceu algo errado. Erro: ${error}`);
        } finally {
            this.loadingRound = false;
        }
    },
    async getEvolucao() {
      this.loadingRound = true;
      try {
      //   console.log('this.pacienteSelecionado.id', this.pacienteSelecionado)
          const response = await api.get(`/remocao/evolcuoes_reusmo/?paciente=${this.pacienteSelecionado}`);
          this.evolucao = response.data.filter(item => item.ativo);
          // console.log('this.evolucao', this.evolucao)
      } catch (error) {
          this.$toast.error(`Desculpe! Aconteceu algo errado. Erro: ${error}`);
      } finally {
          this.loadingRound = false;
      }
    },
    async getEquipamento() {
      this.loadingRound = true;
      try {
      //   console.log('this.pacienteSelecionado.id', this.pacienteSelecionado)
          const response = await api.get(`/pacientes/equipamentos/?paciente=${this.pacienteSelecionado}`);
          this.equipamentos = response.data.filter(item => item.ativo);
          // console.log('this.evolucao', this.equipamentos)
      } catch (error) {
          this.$toast.error(`Desculpe! Aconteceu algo errado. Erro: ${error}`);
      } finally {
          this.loadingRound = false;
      }
    },
    async getIntercorrencia() {
      this.loadingIntercorrencia = true;
      try {
          const response = await api.get(`/remocao/classificacao_acionamentos/?paciente=${this.pacienteSelecionado}&intercorrencia=true`);
          this.intercorrencia = response.data.filter(item => item.ativo);
          // console.log('this.intercorrencia', this.intercorrencia)
      } catch (error) {
          this.$toast.error(`Desculpe! Aconteceu algo errado. Erro: ${error}`);
      } finally {
          this.loadingIntercorrencia = false;
      }
    },
    async getOcorrencia() {
      this.loadingOcorrencia = true;
      try {
          const response = await api.get(`/remocao/classificacao_acionamentos/?paciente=${this.pacienteSelecionado}&intercorrencia=false`);
          this.ocorrencia = response.data.filter(item => item.ativo);
          // console.log('this.ocorrencia', this.ocorrencia)
      } catch (error) {
          this.$toast.error(`Desculpe! Aconteceu algo errado. Erro: ${error}`);
      } finally {
          this.loadingOcorrencia = false;
      }
    },

    formatDate(date) {
      if (!date) return '';
      const [ano, mes, dia] = date.split('-');
      return `${dia}/${mes}/${ano}`;
    },
    formatPhone(phone) {
      const cleaned = ('' + phone).replace(/\D/g, '');
      const match = cleaned.match(/^(\d{2})(\d{4,5})(\d{4})$/);
      return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phone;
    },
    calcularIdade(dataNascimento) {
        if (!dataNascimento) return '';
        const hoje = new Date();
        const nascimento = new Date(dataNascimento);
        let idade = hoje.getFullYear() - nascimento.getFullYear();
        const mes = hoje.getMonth() - nascimento.getMonth();
        if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
            idade--;
        }
        return idade;
    },
    abrirDropdown(event) {
        // Força abrir o menu ao clicar
        const target = event.currentTarget.querySelector('input');
        if (target) {
        target.blur(); // tira o foco do input para não subir o teclado
        }
    },
    abrirExame(caminho) {
    const url = `https://api.gssma.com.br${caminho}`;
    window.open(url, '_blank');
    },
    getNomeArquivo(caminho) {
      if (!caminho) return 'Arquivo sem nome';
      const partes = caminho.split('/');
      return decodeURIComponent(partes[partes.length - 1]);
    },
    formatData(d) {
      if (!d) return '';
      const date = new Date(d);
      const dia = String(date.getDate()).padStart(2, '0');
      const mes = String(date.getMonth() + 1).padStart(2, '0');
      const ano = date.getFullYear();
      return `${dia}/${mes}/${ano}`;
    },
    formatHora(h) {
      if (!h) return '';
      const partes = h.split(':');
      return `${partes[0]}:${partes[1]}`; // pega só horas e minutos
    },
  },

  mounted() {
    this.getPacientes() 
    this.getRound()
  },
  watch: {
    pacienteSelecionado(novoPacienteId) {
      if (novoPacienteId) {
        this.getEvolucao();
        this.getEquipamento();
        this.getIntercorrencia()
        this.getOcorrencia()
      }
    }
  },

};
</script>

<style scoped>

.title-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.scroll-content {
  max-height: calc(100vh - 200px); /* ajuste conforme o layout */
  overflow-y: auto;
  padding-right: 12px;
}

.estilo-linha {
  border: none;
  border-top: 1px solid #1976d2; /* cor azul do Vuetify */
  margin: 10px auto;
  width: 90%;
}
</style>
